module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/conversation icon-174f20a2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/conversation icon.svg
// module id = ./app/web/src/assets/conversation icon.svg
// module chunks = 0